<div fxLayout="row" fxLayoutAlign="center center">
  <mat-card>
    <mat-card-content fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="50px">
      <img src="/assets/leafhill.png" width="150px">
      <app-login-form></app-login-form>
    </mat-card-content>
  </mat-card>
</div>
